// React
import React, { useState } from 'react';

// Styles
import styles from './Header.module.scss';

// Material UI
import {
  Grid,
  Drawer,
  Button,
  ButtonBase,
  Typography,
  useMediaQuery
} from '@material-ui/core';

// Components
import Logo from '../Logo/Logo';
import MainNav from '../MainNav/MainNav';

// This component
export default function Header() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const isLarge = useMediaQuery((theme) => theme.breakpoints.up('lg'));

  const toggleDrawer = (event) => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const closeDrawer = (event) => {
    setIsDrawerOpen(false);
  };

  // JSX
  return (
    <header className={styles.wrapper}>
      <div className={styles.container}>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="center"
          spacing={4}>
          <Grid item>
            <Logo />
          </Grid>

          <Grid item>
            {(() => {
              if (isLarge) {
                if (isDrawerOpen) closeDrawer();
                return (
                  <MainNav isDrawerMenu={false} closeDrawer={closeDrawer} />
                );
              } else {
                return (
                  <ButtonBase
                    className={`${styles['nav-toggle']} ${
                      isDrawerOpen ? styles['nav-toggle--active'] : ''
                    }`}
                    onClick={toggleDrawer}
                    disableRipple={true}>
                    <Typography variant="srOnly">
                      Open Mobile Navigation
                    </Typography>
                    <div className={styles['nav-toggle-icon']}>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </ButtonBase>
                );
              }
            })()}
          </Grid>
        </Grid>

        <Drawer
          classes={{ root: styles['drawer'], paper: styles['drawer-paper'] }}
          anchor="top"
          open={isDrawerOpen}
          onClose={closeDrawer}>
          <MainNav isDrawerMenu={true} closeDrawer={closeDrawer} />
        </Drawer>
      </div>

      <div className={styles['environment-label-container']}>
        {process.env.REACT_APP_ENV === 'staging' &&
          <Button
            className={styles['environment-label']}
            variant="contained"
            disableElevation={true}
            color="secondary"
            size="small"
            >
            DEV Environment
          </Button>
        }        
      </div>

    </header>
  );
}
